import * as z from "@rocicorp/zero"
import * as t from "../generated/schema.ts"
import { tables } from "../generated/schema.ts"

const accountRelationships = z.relationships(t.account, (c) => ({
  channel_memberships: c.many({
    sourceField: ["id"],
    destField: ["account_id"],
    destSchema: t.channel_member,
  }),
  channel_subscriptions: c.many({
    sourceField: ["id"],
    destField: ["account_id"],
    destSchema: t.channel_subscription,
  }),
  messages: c.many({
    sourceField: ["id"],
    destSchema: t.message,
    destField: ["account_id"],
  }),
  organization_memberships: c.many({
    sourceField: ["id"],
    destField: ["account_id"],
    destSchema: t.organization_member,
  }),
  repositories: c.many({
    sourceField: ["id"],
    destSchema: t.repository,
    destField: ["account_id"],
  }),
  repository_memberships: c.many({
    sourceField: ["id"],
    destField: ["account_id"],
    destSchema: t.repository_member,
  }),
  thread_subscriptions: c.many({
    sourceField: ["id"],
    destField: ["account_id"],
    destSchema: t.thread_subscription,
  }),
}))

const attachmentRelationships = z.relationships(t.attachment, (c) => ({
  message: c.one({
    sourceField: ["message_id"],
    destField: ["id"],
    destSchema: t.message,
  }),
}))

const channelRelationships = z.relationships(t.channel, (c) => ({
  accounts: c.many(
    {
      sourceField: ["id"],
      destField: ["channel_id"],
      destSchema: t.channel_member,
    },
    {
      sourceField: ["account_id"],
      destField: ["id"],
      destSchema: t.account,
    },
  ),
  members: c.many({
    sourceField: ["id"],
    destField: ["channel_id"],
    destSchema: t.channel_member,
  }),
  messages: c.many({
    sourceField: ["id"],
    destField: ["channel_id"],
    destSchema: t.message,
  }),
  permissions: c.many({
    sourceField: ["id"],
    destField: ["channel_id"],
    destSchema: t.channel_permission,
  }),
  repository: c.one({
    sourceField: ["repository_id"],
    destField: ["id"],
    destSchema: t.repository,
  }),
  subscriptions: c.many({
    sourceField: ["id"],
    destField: ["channel_id"],
    destSchema: t.channel_subscription,
  }),
}))

const channelMemberRelationships = z.relationships(t.channel_member, (c) => ({
  channel: c.one({
    sourceField: ["channel_id"],
    destField: ["id"],
    destSchema: t.channel,
  }),
  account: c.one({
    sourceField: ["account_id"],
    destField: ["id"],
    destSchema: t.account,
  }),
}))

const channelSubscriptionRelationships = z.relationships(
  t.channel_subscription,
  (c) => ({
    account: c.one({
      sourceField: ["account_id"],
      destField: ["id"],
      destSchema: t.account,
    }),
    channel: c.one({
      sourceField: ["channel_id"],
      destField: ["id"],
      destSchema: t.channel,
    }),
  }),
)

const channelPermissionRelationships = z.relationships(
  t.channel_permission,
  (c) => ({
    channel: c.one({
      sourceField: ["channel_id"],
      destField: ["id"],
      destSchema: t.channel,
    }),
    permission: c.one({
      sourceField: ["permission_id"],
      destField: ["id"],
      destSchema: t.permission,
    }),
  }),
)

const installationRelationships = z.relationships(t.installation, (c) => ({
  account: c.one({
    sourceField: ["account_id"],
    destField: ["id"],
    destSchema: t.account,
  }),
  installation_repositories: c.many({
    sourceField: ["id"],
    destField: ["installation_id"],
    destSchema: t.installation_repository,
  }),
  organization: c.one({
    sourceField: ["organization_id"],
    destField: ["id"],
    destSchema: t.organization,
  }),
  repositories: c.many(
    {
      sourceField: ["id"],
      destField: ["installation_id"],
      destSchema: t.installation_repository,
    },
    {
      sourceField: ["repository_id"],
      destField: ["id"],
      destSchema: t.repository,
    },
  ),
}))

const installationRepositoryRelationships = z.relationships(
  t.installation_repository,
  (c) => ({
    installation: c.one({
      sourceField: ["installation_id"],
      destField: ["id"],
      destSchema: t.installation,
    }),
    repository: c.one({
      sourceField: ["repository_id"],
      destField: ["id"],
      destSchema: t.repository,
    }),
  }),
)

const issueRelationships = z.relationships(t.issue, (c) => ({
  account: c.one({
    sourceField: ["account_id"],
    destField: ["id"],
    destSchema: t.account,
  }),
  repository: c.one({
    sourceField: ["repository_id"],
    destField: ["id"],
    destSchema: t.repository,
  }),
}))

const messageRelationships = z.relationships(t.message, (c) => ({
  account: c.one({
    sourceField: ["account_id"],
    destField: ["id"],
    destSchema: t.account,
  }),
  attachments: c.many({
    sourceField: ["id"],
    destField: ["message_id"],
    destSchema: t.attachment,
  }),
  channel: c.one({
    sourceField: ["channel_id"],
    destField: ["id"],
    destSchema: t.channel,
  }),
  reactions: c.many({
    sourceField: ["id"],
    destField: ["message_id"],
    destSchema: t.reaction,
  }),
  thread: c.one({
    sourceField: ["id"],
    destField: ["message_id"],
    destSchema: t.thread,
  }),
}))

const organizationRelationships = z.relationships(t.organization, (c) => ({
  accounts: c.many(
    {
      sourceField: ["id"],
      destField: ["organization_id"],
      destSchema: t.organization_member,
    },
    {
      sourceField: ["account_id"],
      destField: ["id"],
      destSchema: t.account,
    },
  ),
  members: c.many({
    sourceField: ["id"],
    destField: ["organization_id"],
    destSchema: t.organization_member,
  }),
  repositories: c.many({
    sourceField: ["id"],
    destField: ["organization_id"],
    destSchema: t.repository,
  }),
}))

const organizationMemberRelationships = z.relationships(
  t.organization_member,
  (c) => ({
    organization: c.one({
      sourceField: ["organization_id"],
      destField: ["id"],
      destSchema: t.organization,
    }),
    account: c.one({
      sourceField: ["account_id"],
      destField: ["id"],
      destSchema: t.account,
    }),
  }),
)

const permissionRelationships = z.relationships(t.permission, (_) => ({}))

const pullRequestRelationships = z.relationships(t.pull_request, (c) => ({
  account: c.one({
    sourceField: ["account_id"],
    destField: ["id"],
    destSchema: t.account,
  }),
  repository: c.one({
    sourceField: ["repository_id"],
    destField: ["id"],
    destSchema: t.repository,
  }),
}))

const reactionRelationships = z.relationships(t.reaction, (c) => ({
  account: c.one({
    sourceField: ["account_id"],
    destField: ["id"],
    destSchema: t.account,
  }),
  message: c.one({
    sourceField: ["message_id"],
    destField: ["id"],
    destSchema: t.message,
  }),
}))

const repositoryRelationships = z.relationships(t.repository, (c) => ({
  account: c.one({
    sourceField: ["account_id"],
    destField: ["id"],
    destSchema: t.account,
  }),
  accounts: c.many(
    {
      sourceField: ["id"],
      destField: ["repository_id"],
      destSchema: t.repository_member,
    },
    {
      sourceField: ["account_id"],
      destField: ["id"],
      destSchema: t.account,
    },
  ),
  channels: c.many({
    sourceField: ["id"],
    destField: ["repository_id"],
    destSchema: t.channel,
  }),
  installation: c.one(
    {
      sourceField: ["id"],
      destField: ["repository_id"],
      destSchema: t.installation_repository,
    },
    {
      sourceField: ["installation_id"],
      destField: ["id"],
      destSchema: t.installation,
    },
  ),
  installation_repository: c.one({
    sourceField: ["id"],
    destField: ["repository_id"],
    destSchema: t.installation_repository,
  }),
  issues: c.many({
    sourceField: ["id"],
    destField: ["repository_id"],
    destSchema: t.issue,
  }),
  members: c.many({
    sourceField: ["id"],
    destField: ["repository_id"],
    destSchema: t.repository_member,
  }),
  organization: c.one({
    sourceField: ["organization_id"],
    destField: ["id"],
    destSchema: t.organization,
  }),
  pullRequests: c.many({
    sourceField: ["id"],
    destField: ["repository_id"],
    destSchema: t.pull_request,
  }),
}))

const repositoryMemberRelationships = z.relationships(
  t.repository_member,
  (c) => ({
    repository: c.one({
      sourceField: ["repository_id"],
      destField: ["id"],
      destSchema: t.repository,
    }),
    account: c.one({
      sourceField: ["account_id"],
      destField: ["id"],
      destSchema: t.account,
    }),
  }),
)

const threadRelationships = z.relationships(t.thread, (c) => ({
  message: c.one({
    sourceField: ["message_id"],
    destField: ["id"],
    destSchema: t.message,
  }),
  messages: c.many({
    sourceField: ["id"],
    destField: ["thread_id"],
    destSchema: t.message,
  }),
  subscriptions: c.many({
    sourceField: ["id"],
    destField: ["thread_id"],
    destSchema: t.thread_subscription,
  }),
}))

const threadSubscriptionRelationships = z.relationships(
  t.thread_subscription,
  (c) => ({
    account: c.one({
      sourceField: ["account_id"],
      destField: ["id"],
      destSchema: t.account,
    }),
    thread: c.one({
      sourceField: ["thread_id"],
      destField: ["id"],
      destSchema: t.thread,
    }),
  }),
)

export const schema = z.createSchema({
  enableLegacyMutators: false,
  enableLegacyQueries: false,
  tables,
  relationships: [
    accountRelationships,
    attachmentRelationships,
    channelRelationships,
    channelMemberRelationships,
    channelPermissionRelationships,
    channelSubscriptionRelationships,
    installationRelationships,
    installationRepositoryRelationships,
    issueRelationships,
    messageRelationships,
    organizationRelationships,
    organizationMemberRelationships,
    permissionRelationships,
    pullRequestRelationships,
    reactionRelationships,
    repositoryRelationships,
    repositoryMemberRelationships,
    threadRelationships,
    threadSubscriptionRelationships,
  ],
})
export type schema = typeof schema

export const builder = z.createBuilder(schema)

// TODO: Zero requires an empty permissions object even if we're not using them :(
export const permissions = z.definePermissions(schema, () => ({}))
